import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './Loader.scss';
import { IContent } from '../../../types';

interface ILoaderProps {
  context?: IContent;
  minHeight?: string;
  customColor?: string;
}

const Loader = ({ context, minHeight, customColor }: ILoaderProps) => {
  const dotColor = customColor || "white";
  return (
    <div className="loading" style={{ minHeight }}>
      <span className="dot" style={{ backgroundColor: dotColor }} />
      <span className="dot" style={{ backgroundColor: dotColor }} />
      <span className="dot" style={{ backgroundColor: dotColor }} />
    </div>
  );
};

export default withContent(Loader);
